<script lang="ts" setup>
import type { QuizType } from '@ts-types/quiz/types'
import { defineAsyncComponent } from 'vue'
import { useQuizMainStore } from '@stores/quiz'
// components
const QuizCommonBlocks = defineAsyncComponent(() => import('@components/Content/QuizCommonBlocks.vue'))
const OtpModal = defineAsyncComponent(() => import('@components/Modals/OtpModal.vue'))

defineOptions({
  name: 'QuizLayout'
})

interface QuizLayoutProps {
  alreadyPopupTitle?: string | null
  bgColor?: 'default' | 'gray' | 'white'
  quizType?: QuizType
}

withDefaults(defineProps<QuizLayoutProps>(), {
  alreadyPopupTitle: null,
  bgColor: 'default',
  quizType: 'default'
})

const store = useQuizMainStore()

</script>

<template>
  <div :class="['quiz', bgColor]">
    <slot />
  </div>
  <slot name="otp">
    <OtpModal
      v-if="store.isModalOtp && !store.isModalError"
      :quiz-type="quizType"
    />
  </slot>
  <slot
    v-if="$slots.ela"
    name="ela"
  />
  <slot name="common">
    <QuizCommonBlocks />
  </slot>
</template>

<style scoped lang="scss" src="@scss/layouts/QuizLayout.scss" />
